import { ClientNutritionStatsDto } from "@growth-machine-llc/stridist-api-client";
import React from "react";
import { ClientNutritionStatsCard } from "./ClientNutritionStatsCard";
import { Skeleton } from "@mui/material";

interface ClientNutritionStatsProps {
    stats: ClientNutritionStatsDto;
}

export const ClientNutritionStats = (props: ClientNutritionStatsProps) => {
    const { stats } = props;

    return (stats ? <ClientNutritionStatsCard stats={stats} /> : <Skeleton variant="circular" sx={{height: 55, width: 55, margin: 0.4}} />);
}